import React from 'react';
import { useTranslation } from 'react-i18next';

const FormCheckbox = ({ label, register, name, colSize = 4, onChange=null, disabled=false }) => {
  const { t } = useTranslation();
  const colClass = `col-lg-${colSize} mb-3`;

  return (
    <div className={colClass}>
      <div className="form-group">
        <label className="labelDescription">
          <span className="labelText">{t(label)}</span>
        </label>
        <div className="form-check form-switch form-check-custom form-check-solid">
          <input
            className="form-check-input btnCheck"
            type="checkbox"
            {...register(name)}
            name={name}
            onChange={onChange}
            disabled={disabled}
          />
        </div>
      </div>
    </div>
  );
};

export default FormCheckbox;
